const basico2 = {
    titulo: `JavaScript: variables numéricas y operadores matemáticos`,
    problemas: [
      {
        codigo: 1,
        descripcion: `JavaScript dispone una serie de operadores matemáticos que pueden ser aplicados a números enteros y decimales:
<pre>
+ Suma
- Resta
* Multiplicación
/ División
% Módulo (resto de la división)
** Exponente (potencia) 
</pre>    
  `,
        programa: `let distancia1 = 10
let distancia2 = 20
let suma = distancia1 + distancia2
console.log(suma)`,
        solucion: "30"
      },{
        codigo: 2,
        descripcion: `Podemos hacer la operación directamente cuando llamamos al método log, sin tener que almacenar el valor en una variable:`,
        programa: `let distancia1 = 10
let distancia2 = 20
console.log(distancia1 + distancia2)`,
        solucion: "30"
      },{
        codigo: 3,
        descripcion: `En una operación pueden intervenir varios operadores matemáticos:`,
        programa: `let valor1 = 10
let valor2 = 10
let valor3 = 5
let operacion = valor1 + valor2 - valor3
console.log(operacion)`,
        solucion: "15"
      },{
        codigo: 4,
        descripcion: `Si bien parece sencillo cuando tenemos expresiones con varias operaciones, surge un problema, cual de los operadores matemáticos se ejecuta primero?
<pre>
let resultado = 10 + 10 * 10
</pre>
Primero se ejecuta la operación de multiplicación, por lo que el resultado es 110. A primera vista podríamos pensar que se suma 10 + 10, pero en realidad se ejecuta primero la multiplicación.
`,
        programa: `let distancia1 = 100
let distancia2 = 10
let dias = 4
let total = distancia1 + distancia2 * dias
console.log(total)`,
        solucion: "140"
      },{
        codigo: 5,
        descripcion: `La prioridad de operadores matemáticos en JavaScript es:
<pre>* Multiplicación
/ División
% Módulo (resto de la división)
** Exponente (potencia)
y luego de estos tres:
+ Suma
- Resta
</pre>`,
        programa: `let inicio = 10
let fin = 2
let total = inicio + fin ** 2
console.log(total)`,
        solucion: "14"
      },{
        codigo: 6,
        descripcion: `Si uno tiene dudas sobre el orden de prioridad de los operadores puede encerrar entre paréntesis la expresión que desea evaluar primero. Los paréntesis tienen mayor prioridad que los operadores matemáticos.
<pre>
let valor1 = 10
let valor2 = 10
let valor3 = 10
let resultado = (valor1 + valor2) * valor3
console.log(resultado) 
</pre>
Con los paréntesis primero se suma los contenidos de las variables valor1 y valor2, y luego se multiplica por valor3.
Sin los paréntesis sabemos que primero se multiplica valor2 y valor3 y a dicho resultado se suma valor1.`,
        programa: `let valor1 = 10
let valor2 = 10
let valor3 = 10
let resultado = (valor1 + valor2) * valor3
console.log(resultado)`,
        solucion: "200"
      },{
        codigo: 7,
        descripcion: ``,
        programa: `let valor1 = 10
let valor2 = 10
let valor3 = 10
let resultado = valor1 + valor2 * valor3
console.log(resultado)`,
        solucion: "110"
      },{
        codigo: 8,
        descripcion: `La división de dos valores puede generar un valor entero o decimal.
<code>
let valor1 = 1
let valor2 = 2
let division = valor1 / valor2
console.log(division)
</code>
El resultado es 0.5 `,
        programa: `let nota1 = 10
let nota2 = 9
let nota3 = 8
let promedio = (nota1 + nota2 + nota3) / 3
console.log(promedio)`,
        solucion: "9"
      },{
        codigo: 9,
        descripcion: `En JavaScript las operaciones matemáticas siempre generan un resultado y no dan un error, inclusive con ciertas operaciones que no se pueden realizar, por ejemplo:
<pre>
let distancia = 100
let tiempo = 0
let velocidad = distancia / tiempo
console.log(velocidad)
</pre>
La variable velocidad almacena el valor Infinity.
Si la variable distancia almacena el valor -100 luego la división con respecto a cero genera -Infinity.`,
        programa: `let distancia = -100
let tiempo = 0
let velocidad = distancia / tiempo
console.log(velocidad)`,
        solucion: "-Infinity"
      },{
        codigo: 10,
        descripcion: `Otra situación común que se nos puede presentar en una expresión matemática es que alguna de las variables no esté definida, luego dicha variable almacena el valor undefined. Si operamos con una variable undefined el resultado es un valor especial de JavaScript llamado NaN (Not a Number)`,
        programa: `let distancia = 100
let tiempo 
let velocidad = distancia / tiempo
console.log(velocidad)`,
        solucion: "NaN"
      },{
        codigo: 11,
        descripcion: `El operador % (módulo o resto) es un operador matemático que devuelve el resto de la división de dos valores.
<pre>
let valor1 = 11
let valor2 = 3
let resto = valor1 % valor2
console.log(resto)
</pre>
El resto de dividir 11 entre 3 es 2 (11/3 = 3 partes enteras con resto 2)`,
        programa: `let caramelos = 10
let personas = 3
let sobran = caramelos % personas
console.log(sobran)`,
        solucion: "1"
      },{
        codigo: 12,
        descripcion: `Se debe calcular el cuadrado y el cubo de un número.`,
        programa: `let numero = 10
let cuadrado = numero ** 2
let cubo = numero ** 3
console.log(cubo)`,
        solucion: "1000"
      },{
        codigo: 13,
        descripcion: `Se conoce el sueldo de un trabajador. Incrementar en 25% el sueldo y mostrar el nuevo sueldo a cobrar.`,
        programa: `let sueldo = 1000
let aumento25 = sueldo * 0.25
let sueldoFinal = sueldo + aumento25
console.log(sueldoFinal)`,
        solucion: "1250"
      },{
        codigo: 14,
        descripcion: `Calcular cuanto debe pagar una persona en un hotel si sabemos que el costo de una noche son 50 dolares y la cantidad de noches que se quedará son 5.`,
        programa: `let cantNoches = 5
let precioNoche = 50
let costo = cantNoches * precioNoche
console.log(costo)`,
        solucion: "250"
      },{
        codigo: 15,
        descripcion: `Se sabe cuanto pesa un producto en kilos, calcular dicho peso en libras, sabiendo que 1kg es igual a 2.205 libras.`,
        programa: `let pesoKilos = 10
let libra = 2.205
let pesoLibras = pesoKilos * libra
console.log(pesoLibras)`,
        solucion: "22.05"
      },{
        codigo: 16,
        descripcion: `Se conoce que el lado de un cuadrado es 5, mostrar el valor del perímetro del mismo (recordar que el perímetro resulta de multiplicar el valor del lado por 4)`,
        programa: `let lado = 5
let perimetro = lado * 4
console.log(perimetro)`,
        solucion: "20"
      },{
        codigo: 17,
        descripcion: `Se conoce el precio de un producto y la cantidad de productos a llevar. Calcular e imprimir el importe a pagar.`,
        programa: `let precio = 10.50
let cantidad = 3
console.log(precio * cantidad)`,
        solucion: "31.50"
      },{
        codigo: 18,
        descripcion: `Confeccionar un programa que muestre la cantidad de horas que tiene un día. La cantidad de minutos y la cantidad de segundos. Efectuar las operaciones para calcular los minutos y los segundos.`,
        programa: `let horasDia = 24
let minutosDia = horasDia * 60
let segundosDia = minutosDia * 60
console.log(segundosDia)`,
        solucion: "86400"
      }
    ]
  }
  
  export default basico2;